import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-menu-header',
  templateUrl: './nav-menu-header.component.html',
  styleUrls: ['./nav-menu-header.component.scss']
})
export class NavMenuHeaderComponent {

}
